import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { http } from '@/apis/aipass'
import { SurveySkipRequest, SurveySkipResponse } from './survey-types'
import { env } from '@/libs/env'

export const skipSurvey = createAsyncThunk<SurveySkipResponse, SurveySkipRequest, { rejectValue }>(
  'survey/skipSurvey',
  async (params: SurveySkipRequest, { rejectWithValue }) => {
    try {
      const response = await http({
        method: 'post',
        url: `${env('BASE_API_V3')}/guest/surveys/skip`,
        data: {
          hotelId: params.hotelId,
          reservationIds: params.reservationIds,
          responseSource: params.responseSource,
        },
      })
      return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

interface SurveySkipState {
  skipResponse: SurveySkipResponse | null
  loading: boolean
}

const initialState: SurveySkipState = {
  skipResponse: null,
  loading: false,
}

const surveySkipSlice = createSlice({
  name: 'surveySkip',
  initialState,
  reducers: {
    resetSurveySkip: state => {
      state.skipResponse = null
      state.loading = false
    },
  },
  extraReducers: builder => {
    builder.addCase(skipSurvey.fulfilled, (state, action) => {
      state.skipResponse = action.payload
      state.loading = false
    })
    builder.addCase(skipSurvey.rejected, state => {
      state.loading = false
    })
    builder.addCase(skipSurvey.pending, state => {
      state.loading = true
    })
  },
})

export const { resetSurveySkip } = surveySkipSlice.actions
export const surveySkipReducer = surveySkipSlice.reducer
